export const getTechAvatars = (technicianIds: string[]) => {
  return {
    method: 'GET',
    url: `${
      process.env.REACT_APP_ORIGIN
    }/technicians/avatars?techObjectIds=${JSON.stringify(technicianIds)}`,
  }
}

export const getGeocode = (address: string) => {
  return {
    method: 'GET',
    url: `${
      process.env.REACT_APP_ORIGIN
    }/locations/geocode?address=${encodeURIComponent(address)}`,
  }
}

//not working
export const getAvailableTechsForRoute = (date: string, locationId: string) => {
  const isoDate = new Date(date).toISOString()
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/available/${locationId}/${isoDate}`,
  }
}
//untested as get tech doesn't work
export const resetTechToRouteArea = (
  routeObjectId: string,
  technicianId: string,
) => {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/route_areas/${routeObjectId}/technician`,
    body: technicianId,
  }
}
//untested as get tech doesn't work
export const resetTechToRoute = (
  routeObjectId: string,
  technicianId: string,
) => {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/routes/${routeObjectId}/technician`,
    body: technicianId,
  }
}

export const getFirstAvailableApp = (zipCode: string) => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/zips/${zipCode}/available-date`,
  }
}

export const isLocationServicedCheck = (zipCode: string) => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/zips/${zipCode}/availability`,
  }
}
export const getLocationById = (locationId: string) => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/locations/${locationId}`,
  }
}
